<template>
    <gofix-card fullContent class="mb-0">
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @new-item="openModalItem"
            @load-items="getTableData"
            @row-click="openModalItem"
            @delete-items="deleteItems"
            ref="gofixTable">
            <template slot="gofix_table:id" slot-scope="row">
                {{ row.index + 1 }}
            </template>
            <template slot="gofix_table:weight" slot-scope="row">
                {{ row.item.weight ? `${row.item.weight}%` : '0%' }}
            </template>
        </gofix-table>
        <b-modal :no-close-on-backdrop="true" id="modal-create-orders" :title="modal.title" hide-footer :centered="true" v-model="modal.open" ref="modal-create-orders">
                <b-form class="formV2">
                    <gofix-form-dropdown
                            label="Maintenance Type"
                            vLabel="description_one"
                            :clearable="false"
                            :filterable="false"
                            :options="modal.options.maintenance_types"
                            v-model="modal.data.maintenance"
                            @search="searchMaintProgram">
                        <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                            <span class="text-hidden-one-row">{{ option.description_one || '-' }}</span>
                        </template>
                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                            <div class="maintOption">
                                <!-- <p><strong>{{ option.sor_code }}</strong></p> -->
                                <span>{{ option.description_one || '-' }}</span>
                            </div>
                        </template>
                    </gofix-form-dropdown>
                    <!-- <gofix-form-dropdown
                        label="Maintenance Type"
                        v-model="modal.data.maintenance_type"
                        :options="modal.options.maintenance_types">
                    </gofix-form-dropdown> -->
                    <gofix-form-input-number
                        label="Weightage [%]"
                        v-model="modal.data.weight"
                        :integer-limit="3"
                        suffix="%">
                    </gofix-form-input-number>
                </b-form>
                <b-button-group class="d-block text-right pr-4">
                    <gofix-button label="SUBMIT" @click="saveItem" :loading="modal.loading" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
    </gofix-card>
</template>
<script>
import { filters } from '@/_filterVar.js'
export default {
    name: 'performance_assesment_maintenance_regime_weightage',
    props: {
        propertyType: {
            type: String,
            default: '',
        },
        contract: {
            type: Object,
            default: () => null,
        }
    },
    data() {
        let filter =  JSON.parse(JSON.stringify(filters['performance_assesment_maintenance_weight']));
        return {
            tableConfig:{
                name: 'performance-assesment-maintenance-weight',
                controls:{
                    create: true,
                    update: true,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false
                },
                filter: filter,
                page: 1,
                limit: 100,
                sortColumn: "id",
                sortDirection: "asc",
                fields: [
                    {
                        key: 'actions',
                        label: '',
                        thClass: 'checkbox-column text-center',
                        tdClass: 'checkbox-column text-center',
                        width: 50,
                        thStyle: "width:50px",
                    },
                    {
                        key: 'id',
                        label: 'No.',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width:100px",
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'maintenance_name',
                        label: 'Maintenance Type',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width:350px",
                        sorting: true,
                    },
                    {
                        key: 'weight',
                        label: 'Weightage (%)',
                        isActive: 1,
                        isFilter: true,
                        sorting: true,
                    },
                ]
            },
            tableItems: [],
            supplier_contracts: [],
            modal: {
                title: '',
                open: false,
                loading: false,
                options: {
                    maintenance_types: ['AES Daily Cleaning Inspection (RES)', 'AES Weekly Inspection Type 1 (RES)', 'AES Weekly Inspection Type 2 (RES)', 'AES Monthly Washing Inspection (RES)', 'AES Quarterly Maintenance Inspection (RES)']
                },
                data: {
                    contract_id: null,
                    property_type: null,
                    maintenance: null,
                    weight: null
                }
            },
            timer: {
                maint: null,
                save: null
            }
        }
    },
    watch: {
        propertyType: function() {
            this.$refs.gofixTable.reloadTableItems();
        },
        contract: function() {
            this.$refs.gofixTable.reloadTableItems();
        }
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest , resolve,reject } = await callback();
            if(!this.contract || !this.propertyType) {
                this.tableItems = []
                this.tableConfig.total = 0
                resolve({
                    items: [],
                    total: 0
                })
                return
            }
            tableRequest.filter.property_type.value = this.propertyType
            tableRequest.filter.contract_id.value = this.contract.id
            tableRequest.type_setting = 'pa_maintenance_weight_setting'
            await this.$store.dispatch("PerformanceAssesmentSettingsController/getItems", tableRequest)
            .then(response => {
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                resolve(response);
            })
            .catch(err => {
                this.$alertNotification("Can not load the maintenance type weightage", "danger");
                reject();
            })
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("PerformanceAssesmentSettingsController/deleteItems", {
                ids: ids,
                type: 'pa_maintenance_weight_setting'
            })
            .then(response => {
                resolve( 'Successfully deleted maintenance type weightage' );
            })
            .catch(err =>{
                reject(err);
            });
        },
        async openModalItem(item){
            if(item){
                this.modal.title = 'Edit Item'
                this.modal.data = Object.assign(this.modal.data, item)
            } else {
                if(!this.propertyType) return this.$alertNotification("Please select a property type", "danger");
                if(!this.contract) return this.$alertNotification("Please select a supplier contract", "danger");
                this.modal.title = 'Create Item'
                this.modal.data = {
                    contract_id: this.contract.id,
                    property_type: this.propertyType,
                    maintenance: null,
                    weight: null
                }
            }
            this.getMaintProgram()
            this.modal.open = true;
        },
         async getMaintProgram(search = null) {
            let filters = {
                search:         search,
                is_maintenance: true,
                is_master:      false,
                property_type:  this.modal.data.property_type,
                report_type: 'AES',
            }
            
            await this.$store.dispatch("v2SorController/getItems", {
                isCMS: false,
                page: -1,
                limit: 100,
                group_id: 0,
                filter: filters,
                supplier_contract_id: this.modal.data.contract_id
            })
            .then(response => {
                this.modal.options.maintenance_types = response.items
            })
            .catch(err => {
                this.modal.options.maintenance_types = [];
            })
        },
        async searchMaintProgram(search, loading) {
            loading(true)
            this.modal.options.maintenance_types = []
            if (this.timer.maint) {
                clearTimeout(this.timer.maint);
                this.timer.maint = null;
            }
            this.timer.maint = setTimeout(async () => {
                try {
                    await this.getMaintProgram(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        saveItem() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(() => {
                if(!this.modal.data.maintenance) return this.$alertNotification("Maintenance type is required", "danger")
                if(!this.modal.data.weight) return this.$alertNotification("Weight is required", "danger")

                if(this.modal.loading) return
                this.modal.loading = true

                const request = {
                    id: this.modal.data.id || null,
                    property_type: this.modal.data.property_type,
                    contract_id: this.modal.data.contract_id,
                    maintenance_id: this.modal.data.maintenance.id,
                    maintenance_name: this.modal.data.maintenance.description_one,
                    weight: this.$accounting.unformat(this.modal.data.weight)
                }

                this.$store.dispatch(`PerformanceAssesmentSettingsController/${!request.id ? 'createMaintenanceWeight' : 'updateMaintenanceWeight'}`, request)
                    .then(response => {
                        this.modal.loading = false
                        this.modal.open = false
                        this.$refs.gofixTable.reloadTableItems();
                        this.$alertNotification(this.$notificationV2(!request.id ? 'adding' : 'editing', 'pa_maintenance_weight'));
                    })
                    .catch(err => {
                        console.log(err)
                        this.modal.loading = false
                        if (err.response.data.error && err.response.data.error.message) {
                            this.$alertNotification(err.response.data.error.message, "danger")
                        }
                    })
            }, 200)
        }
    }
}
</script>